<template>
    <div class="app-container">
        <el-row :gutter="20">
            <el-col :offset="3" :span="18">
                <h3>{{ user.prenom }} {{ user.name }}</h3>
                <user-data :user="user" />
            </el-col>
        </el-row>
    </div>
</template>

<script>
import Resource from "@/api/resource";
import UserData from "./components/UserData";
const userResource = new Resource("users");

export default {
    name: "Profile",
    components: { UserData },
    data() {
        return {
            user: {}
        };
    },
    watch: {
        // $route: "getUser"
    },
    created() {
        console.log("PROFILE-CREATED");
        const id = this.$route.params && this.$route.params.id;
        this.getUser(id);
    },
    methods: {
        async getUser(id) {
            console.log("getUser");
            const { data } = await userResource.get(id);
            this.user = data;
        }
    }
};
</script>
